<div [hidden]="!(visible$ | async)">
    <div class="modal-backdrop fade show"></div>
    <div class="d-block modal fade show">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Statistik</h4>
                    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
                </div>

                <div class="modal-body" *ngIf="step$ | async as step">
                    <ul class="nav nav-tabs card__tabs" *ngIf="lev$ | async as lev">
                        <ng-container *ngFor="let tab of tabs">
                            <li *ngIf="tab.lev ? lev >= tab.lev : true" class="nav-item">
                                <div [class.active]="step === tab.step" (click)="gotoTab(tab)" class="nav-link">
                                    {{tab.text}}
                                </div>
                            </li>
                        </ng-container>
                    </ul>

                    <app-statistik-produktivitet [hidden]="step !== 1"></app-statistik-produktivitet>
                    <app-statistik-tidsforbrug [hidden]="step !== 2"></app-statistik-tidsforbrug>
                    <app-statistik-kunder [hidden]="step !== 3"></app-statistik-kunder>
                    <app-statistik-igangvaerende [hidden]="step !== 4"></app-statistik-igangvaerende>
                    <app-statistik-daekning [hidden]="step !== 5"></app-statistik-daekning>
                    <app-statistik-ydelse [hidden]="step !== 6"></app-statistik-ydelse>
                    <app-statistik-normtid [hidden]="step !== 7"></app-statistik-normtid>
                    <app-statistik-tilafgang [hidden]="step !== 8"></app-statistik-tilafgang>
                    <app-statistik-netomsla [hidden]="step !== 9"></app-statistik-netomsla>
                </div>
            </div>
        </div>
    </div>
</div>
